import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Container, Alert, Spinner, Button } from "react-bootstrap";
import { API_BASE_URL } from "../../api";

const EmailVerification = () => {
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");
  const { token } = useParams();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/auth/verify/${token}`
        );
        setStatus("success");
        setMessage(response.data.message);
      } catch (error) {
        setStatus("error");
        setMessage(
          error.response?.data?.error ||
            "An error occurred during verification."
        );
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <Container className="mt-5">
      <h2 className="text-center mb-4">Email Verification</h2>
      {status === "verifying" && (
        <div className="text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Verifying...</span>
          </Spinner>
          <p className="mt-3">Verifying your email address...</p>
        </div>
      )}
      {status === "success" && (
        <Alert variant="success">
          <Alert.Heading>Email Verified Successfully!</Alert.Heading>
          <p>{message}</p>
          <hr />
          <div className="d-flex justify-content-end">
            <Link to="/signin">
              <Button variant="outline-success">Proceed to Sign In</Button>
            </Link>
          </div>
        </Alert>
      )}
      {status === "error" && (
        <Alert variant="danger">
          <Alert.Heading>Verification Failed</Alert.Heading>
          <p>{message}</p>
          <hr />
          <p className="mb-0">
            If you're having trouble verifying your email, please contact
            support.
          </p>
        </Alert>
      )}
    </Container>
  );
};

export default EmailVerification;
